import * as InboxActions from "./inboxActions";

export default InboxActions;
